import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/system/Unstable_Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { isEmpty, map } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { ArtImage } from "../../../components/ArtImage";
import { Autocomplete } from "../../../components/Autocomplete";
import { listBackgrounds, listFormats } from "../../../services/studio";
import { Background, Format } from "../../../types/studio";
import { DialogNewBackgroud } from "../DialogNewBackgroud";
import { DeleteOutlineRounded } from "@mui/icons-material";
import { RED } from "../../../utils/colors";
import { useDialogConfirmation } from "../../../hooks/useDialogConfirmation";

export function MyBackgrounds() {
  const dialog = useDialogConfirmation();
  const [dialogNewBackgroundOpen, setDialogNewBackgroundOpen] =
    useState<boolean>(false);
  const [selectedFormats, setSelectedFormats] = useState<Format[]>();

  const handleDialogNewBackground = useCallback(() => {
    setDialogNewBackgroundOpen((prevState) => !prevState);
  }, []);

  const formatsBackgrounds = useMemo(() => {
    return selectedFormats?.map((format) => format.id).toString() as string;
  }, [selectedFormats]);

  const formats = useQuery("formats", listFormats);

  const backgrounds = useQuery(["backgrounds", formatsBackgrounds], () =>
    listBackgrounds({ formats: formatsBackgrounds })
  );

  const handleDelete = useCallback(
    (id: number) => {
      dialog.show(
        "Excluir fundo?",
        "Tem certeza que deseja excluir este fundo?",
        {
          onConfirmate: () => {
            console.log(id);
            dialog.close();
          },
        }
      );
    },
    [dialog]
  );

  const RenderOverlay = (data: Background) => {
    return (
      <Stack direction="row" justifyContent="flex-end">
        <Button
          onClick={() => {
            handleDelete(data.id);
          }}
          disableElevation
          size="small"
          variant="contained"
          color="inherit"
          sx={{ color: RED, minWidth: 0 }}
        >
          <DeleteOutlineRounded />
        </Button>
      </Stack>
    );
  };

  return (
    <>
      <Stack spacing={2}>
        <Stack spacing={2} direction="row" width="30%">
          <Autocomplete
            multiple
            fullWidth
            size="small"
            label="Formatos"
            options={formats.data}
            getOptionLabel={(option) => option.name}
            loading={formats.isLoading}
            value={selectedFormats}
            onChange={(_, formats) => {
              setSelectedFormats(formats);
            }}
          />
          <Button
            onClick={handleDialogNewBackground}
            fullWidth
            size="small"
            color="primary"
            variant="contained"
          >
            Importar fundo
          </Button>
        </Stack>
        <Grid container spacing={2}>
          {backgrounds.isLoading ? (
            <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
              <CircularProgress />
            </Grid>
          ) : isEmpty(backgrounds.data) ? (
            <Grid xs={12} justifyContent="center" sx={{ display: "flex" }}>
              <Typography color="GrayText">
                Lista de meus fundos vazia.
              </Typography>
            </Grid>
          ) : (
            map(backgrounds.data, (model, index) => (
              <Grid xs={2} key={index}>
                <ArtImage
                  overlayComponent={<RenderOverlay {...model} />}
                  image={model.imageURL}
                  name={model.name}
                />
              </Grid>
            ))
          )}
        </Grid>
      </Stack>
      <DialogNewBackgroud
        open={dialogNewBackgroundOpen}
        onClose={handleDialogNewBackground}
      />
    </>
  );
}
